module.exports = __FOREMAN_VENDOR__REACT_DND__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_DND__"
// module id = react-dnd
// module chunks = 0